module.exports = __webpack_public_path__ + "static/BeFunky-collage-55881360ea42c192f29a929654a9cf7d.jpg";